import { apiUri, requestMethod, requestMethodWithoutToken } from './common';
import { convertJson } from '../../utils/convert_helper';
import { getAccessTokenFromStorage } from "./auth";
import axios, { AxiosError } from "axios";

const schoolUri = "school/"
const sceneUri = "scenes/"
const studioUri = "studio/"
const shotUri = "phototimerecords/"
const selectPhotoScheduleUri = "photo-select-schedules/"
const apiGatewayBaseUri = "https://0dk5a0h5wf.execute-api.ap-northeast-2.amazonaws.com"

export const login = (email, password) => {
    console.log(apiUri)
    return requestMethodWithoutToken.post({ endPoint: apiUri + 'token/', body: { email, password } })
}

export const getMe = () => {
    return requestMethod.get({ endPoint: apiUri + "users/me/" })
}

const registerSchool = (schoolData) => {
    return requestMethod.post({ endPoint: apiUri + schoolUri, body: convertJson(schoolData) })
}

const getSchools = (contract_year) => {
    return requestMethod.get({ endPoint: apiUri + schoolUri, params: { contract_year } })
}

const getContractYears = () => {
    return requestMethod.get({ endPoint: apiUri + "school/contract-years/" })
}

const getScenes = (schooId) => {
    return requestMethod.get({ endPoint: apiUri + sceneUri, params: { school_id: schooId } })
}

const createScene = (sceneData) => {
    return requestMethod.post({ endPoint: apiUri + sceneUri, body: convertJson(sceneData) })
}

const startPhoto = (shotData) => {
    return requestMethod.post({ endPoint: apiUri + shotUri, body: convertJson(shotData) })
}

const endPhoto = (shotId) => {
    let data = {
        end_time: new Date().toISOString()
    }
    return requestMethod.patch({
        endPoint: apiUri + shotUri + shotId + "/", body: convertJson(data)
    })
}

const uploadPhotos = (formData, { setProgress }) => {
    return axios.post(apiUri + "photo/upload/", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getAccessTokenFromStorage()}`,
        },
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setProgress(percentCompleted);
        }
    })
}

const getUploadedPhotos = (schoolId, classroomId) => {
    return requestMethod.get({ endPoint: apiUri + `photo/upload?schoolId=${schoolId}&classroomId=${classroomId}` })
}

export const deleteUploadedPhoto = (photoId) => {
    return requestMethod.delete({ endPoint: apiUri + `photo/upload/?photoId=${photoId}` })
}

export const getSelectedPhotos = (schoolId) => {
    return requestMethod.get({ endPoint: apiUri + `selected-photos/?schoolId=${schoolId}` })
}

export const getTeahcersInfo = (schoolId) => {
    return requestMethod.get({ endPoint: apiUri + `studio/teachers/${schoolId}/` })
}

export const getTempPassword = () => {
    return requestMethod.get({ endPoint: apiUri + `temp-password/` })
}

export const createTempPassword = (available_on) => {
    return requestMethod.post({ endPoint: apiUri + `temp-password/`, body: { available_on } })
}

export const freelancerLogin = (data) => {
    return requestMethodWithoutToken.post({ endPoint: apiUri + `freelancer-login/`, body: convertJson(data) })
}



// Scene Schedule APIs
export const getSceneSchedule = (sceneId) => {
    return requestMethod.get({ endPoint: apiUri + sceneUri + `${sceneId}/schedule/` })
}

export const updateSceneSchedule = (sceneId, data) => {
    return requestMethod.patch({ endPoint: apiUri + sceneUri + `${sceneId}/schedule/`, body: convertJson(data) })
}

export const startSceneSchedule = (sceneId) => {
    return requestMethod.post({ endPoint: apiUri + sceneUri + `${sceneId}/schedule/start/` })
}

export const endSceneSchedule = (sceneId) => {
    return requestMethod.post({ endPoint: apiUri + sceneUri + `${sceneId}/schedule/end/` })
}

export const getStudentUnselectedPhotos = (studentId) => {
    return requestMethod.get({ endPoint: apiUri + `photo/manual-select/?studentId=${studentId}` })
}

export const selectStudentPhoto = (data) => {
    return requestMethod.post({ endPoint: apiUri + `photo/manual-select/`, body: convertJson(data) })
}

export const getUnmatchedPhotos = (schoolId) => {
    return requestMethod.get({ endPoint: apiUri + `photo/manual-matching/?schoolId=${schoolId}` })
}

export const matchPhoto = (data) => {
    return requestMethod.post({ endPoint: apiUri + `photo/manual-matching/`, body: convertJson(data) })
}

export const getSchoolStudents = (schoolId) => {
    return requestMethod.get({ endPoint: apiUri + `school/${schoolId}/students/` })
}

export const getClassroomStudentsAPI = (schoolId, classroomId) => {
    return requestMethod.get({ endPoint: apiUri + `school/${schoolId}/students/?classroomId=${classroomId}` })
}

export const requestChangePassword = (data) => {
    return requestMethod.post({ endPoint: apiUri + `studio/new-password/`, body: convertJson(data) })
}

export const getAllSchoolFileCondition = (schoolId) => {
    return requestMethod.get({ endPoint: apiUri + `photo/selected/all-school-file/?schoolId=${schoolId}` })
}

export const createAllSchoolFile = (data) => {
    return requestMethod.post({ endPoint: apiUri + `photo/selected/download/`, body: convertJson(data) })
}

export const fetchCurrentTime = () => {
    return requestMethod.get({ endPoint: apiUri + `time/` })
}

// 졸업앨범 관련 API

// 졸업영상 API
export const getGraduationVideos = (schoolId) => {
    return requestMethod.get({ endPoint: apiUri + `graduation-album/videos/?school_id=${schoolId}` })
}

export const getVideoPresignedUploadUrl = (uploadData) => {
    return requestMethod.post({
        endPoint: apiUri + `graduation-album/videos/presigned_upload/`,
        body: convertJson(uploadData)
    })
}

export const completeVideoUpload = (uploadData) => {
    return requestMethod.post({
        endPoint: apiUri + `graduation-album/videos/upload_complete/`,
        body: convertJson(uploadData)
    })
}

export const getVideoDownloadUrl = (videoId) => {
    return requestMethod.get({
        endPoint: apiUri + `graduation-album/videos/${videoId}/download_url/`
    })
}

// 졸업앨범 PDF API
export const getGraduationPdfs = (schoolId) => {
    return requestMethod.get({ endPoint: apiUri + `graduation-album/pdfs/?school_id=${schoolId}` })
}

export const getPdfPresignedUploadUrl = (uploadData) => {
    return requestMethod.post({
        endPoint: apiUri + `graduation-album/pdfs/presigned_upload/`,
        body: convertJson(uploadData)
    })
}

export const completePdfUpload = (uploadData) => {
    return requestMethod.post({
        endPoint: apiUri + `graduation-album/pdfs/upload_complete/`,
        body: convertJson(uploadData)
    })
}

export const getPdfDownloadUrl = (pdfId) => {
    return requestMethod.get({
        endPoint: apiUri + `graduation-album/pdfs/${pdfId}/download_url/`
    })
}

// 삭제 API
export const deleteGraduationVideo = (videoId) => {
    return requestMethod.delete({
        endPoint: apiUri + `graduation-album/videos/${videoId}/`
    })
}

export const deleteGraduationPdf = (pdfId) => {
    return requestMethod.delete({
        endPoint: apiUri + `graduation-album/pdfs/${pdfId}/`
    })
}

export const getSceneMatchingStatus = (sceneId) => {
    return requestMethod.get({ endPoint: apiUri + `scenes/${sceneId}/matching-status/` })
}

export const setSceneTimeOffset = (sceneId, offsetSeconds) => {
    return requestMethod.patch({
        endPoint: apiUri + `scenes/${sceneId}/time-offset/`,
        body: { time_offset_seconds: offsetSeconds }
    })
}

export { registerSchool, getSchools, getContractYears, getScenes, createScene, startPhoto, endPhoto, uploadPhotos, getUploadedPhotos }
